import { Check } from "lucide-react";
import type { ReactNode } from "react";

export interface OnboardingAutoFlowItem {
  /** Body copy. Wrap accent words in <strong> if needed. */
  label: ReactNode;
  /** Right-side mono badge (e.g. "Automático"). Optional. */
  badge?: ReactNode;
}

interface OnboardingAutoFlowPanelProps {
  /** Mono uppercase header copy, e.g. "Esto es lo que Fiscalo hace por vos". */
  head: ReactNode;
  items: OnboardingAutoFlowItem[];
}

/**
 * Auto-flow transparency panel — appears below the Modo choice grid when
 * "automático" is selected. Shows the user exactly what Fiscalo is about to
 * do, without leaving the screen.
 */
export function OnboardingAutoFlowPanel({
  head,
  items,
}: OnboardingAutoFlowPanelProps): JSX.Element {
  return (
    <div className="fx-onb-autoflow">
      <div className="fx-onb-autoflow-head">{head}</div>
      {items.map((item, i) => (
        <div key={i} className="fx-onb-autoflow-row">
          <span className="tile" aria-hidden>
            <Check />
          </span>
          <span>{item.label}</span>
          {item.badge ? <span className="badge">{item.badge}</span> : <span />}
        </div>
      ))}
    </div>
  );
}
